// extracted by mini-css-extract-plugin
export default {"errorContainer":"Layout_errorContainer__wAM9k","viewFullscreenRoot":"Layout_viewFullscreenRoot__Bedq4"};